export default __webpack_public_path__ + "static/media/radio_t.87fbbc1a.svg";